import React, { Component } from "react"
import { Link } from "gatsby"
import { FaArrowLeft } from "react-icons/fa"
import DatePicker from "react-datepicker"
import { navigate } from "@reach/router"
import moment from "moment"
import axios from "axios"

import BookStyles from "./book.module.scss"
import "react-datepicker/dist/react-datepicker.css"

class Book extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: "",
      phone: "",
      pickedTime: "Pick a time",
      availableTimes: null,
      services: props.services ? props.services : [],
      startDate: undefined,
      selectedAnyServices: false,
      error: undefined,
      success: undefined,
      bookedAppointment: false,
    }
  }

  clearError = () => {
    this.setState({
      error: undefined,
    })
  }

  setSuccess = () => {
    this.setState({
      success: "Your appointment has been successfully booked!",
    })
  }

  resetForm = () => {
    this.setState(prevState => ({
      name: "",
      phone: "",
      pickedTime: "Pick a time",
      availableTimes: null,
      services: prevState.services.map(service => {
        service.checked = false
        return service
      }),
      startDate: undefined,
      selectedAnyServices: false,
      error: undefined,
    }))
  }

  handleDateChange = date => {
    this.setState(
      {
        startDate: date,
        availableTimes: null,
      },
      () => {
        this.fetchAvailableTimes(date)
      }
    )
  }

  handleTimeChange = event => {
    this.setState({
      pickedTime: event.target.value,
    })
  }

  // Handle text input change
  handleNameChange = e => {
    this.setState({
      name: e.target.value,
    })
  }

  // Handle text input change
  handlePhoneChange = e => {
    if (!/^\d*$/.test(e.target.value)) return

    this.setState({
      phone: e.target.value,
    })
  }

  // Manage checkboxes with state
  handleCheckbox = e => {
    const checkedService = e.target.value

    this.setState({ selectedAnyServices: true })

    this.setState(prevState =>
      prevState.services.map(service => {
        if (service.service === checkedService) {
          service.checked = !service.checked
        }
        return service
      })
    )
  }

  fetchAvailableTimes = date => {
    const self = this
    const url =
      "https://appointment-system.onrender.com/api/getBarberAvailableTimes"

    const { barber } = this.props

    const data = {
      barber,
      fromDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      services: this.state.services
        .filter(service => service.checked)
        .map(service => ({
          service: service.service,
          duration: service.duration,
          price: service.price,
        })),
    }

    axios
      .post(url, data)
      .then(function(response) {
        self.setState({
          availableTimes: response.data.availableTimes,
        })
      })
      .catch(function(error) {
        self.setState({
          error: "Oh-oh! It looks like there was an error fetching the times.",
        })
      })
  }

  // Update state form data
  handleSubmit = e => {
    e.preventDefault()

    const { barber, postURL, walkin, book } = this.props
    const { name, phone, startDate, pickedTime, services } = this.state

    const selectedServices = services.filter(service => service.checked)

    const walkinNotComplete = !name || !phone || selectedServices.length === 0

    const bookNotComplete =
      !name ||
      !phone ||
      !startDate ||
      pickedTime.includes("time") ||
      selectedServices.length === 0

    if ((book && bookNotComplete) || (walkin && walkinNotComplete)) {
      return this.setState({
        error: "Please fill out all fields",
      })
    }

    this.setState({
      bookedAppointment: true,
    })

    const data = book
      ? {
          barber,
          name: name,
          phoneNumber: phone,
          date: moment(this.state.startDate).format("MM-DD-YYYY"),
          time: this.state.pickedTime,
          services: this.state.services.filter(service => service.checked),
        }
      : {
          barber,
          name: name,
          phoneNumber: phone,
          services: services
            .filter(service => service.checked)
            .map(service => ({
              price: service.price,
              service: service.service,
              duration: service.duration,
            })),
        }

    axios
      .post(postURL, data)
      .then(response => {
        this.resetForm()
        this.setState({
          success:
            "Your appointment has been successfully booked! You will recieve a confirmation text shortly.",
        })
      })
      .catch(error => {
        this.setState({
          bookedAppointment: false,
          error:
            "Uh-oh! It looks like something went wrong! Please contact email@example.com.",
        })
      })
  }

  renderAvailableTimes = () => {
    const options = this.state.availableTimes
      .filter(time => {
        const now = moment()
        const hour = moment(time, "ddd, MMMM Do, hh:mm a")

        return now.isBefore(hour)
      })
      .map(time => <option key={time}>{time}</option>)

    return options.length === 0 ? (
      <p>Sorry! There are no available times for that day.</p>
    ) : (
      <select
        value={this.state.pickedTime}
        onChange={this.handleTimeChange}
        className={BookStyles.availableTimes}
      >
        <option value="Pick a time" disabled>
          Pick a time
        </option>
        {options}
      </select>
    )
  }

  componentDidMount() {
    if (!this.props.barber) {
      navigate("/cue")
    }
  }

  render() {
    const { barber } = this.props
    const { services, name, phone, availableTimes } = this.state

    const selectedServices = services.filter(service => service.checked)

    // Render service checkboxes from services array passed as props
    const servicesList = services.map(service => (
      <label
        key={service.service}
        className="input-container input-container--sm"
      >
        {service.service} - ${service.price}
        <input
          type="checkbox"
          id={service.service}
          name={service.service}
          value={service.service}
          checked={service.checked}
          style={{ marginRight: "10px" }}
          onChange={this.handleCheckbox}
        />
        <span className="checkmark"></span>
      </label>
    ))

    // Get checked services total
    const total = this.state.services
      .filter(service => service.checked)
      .reduce((total, service) => total + service.price, 0)

    return (
      <section className={BookStyles.content}>
        <Link to="/cue/">
          <FaArrowLeft style={{ marginRight: "5px" }} />
          Go Back
        </Link>

        <form onSubmit={this.handleSubmit}>
          <div className={BookStyles.formGroup}>
            <h2>Client details</h2>

            <div className={BookStyles.formItem}>
              <label htmlFor="name">Name *</label>
              <input
                required
                id="name"
                type="text"
                name="name"
                value={name}
                onChange={this.handleNameChange}
              />
            </div>

            <div className={BookStyles.formItem}>
              <label htmlFor="phone">Phone number *</label>
              <input
                required
                id="phone"
                type="text"
                name="phone"
                value={phone}
                maxLength="10"
                placeholder="9209996473"
                onChange={this.handlePhoneChange}
                pattern="\d{10}"
              />
            </div>
          </div>

          <div className={BookStyles.formGroup}>
            <h2>Services</h2>
            {servicesList}
          </div>

          {this.props.book && (
            <>
              <div className={BookStyles.formGroup}>
                <h2>Date</h2>
                {selectedServices.length > 0 ? (
                  <DatePicker
                    placeholderText="Pick a date"
                    dateFormat="MMMM d, yyyy"
                    minDate={moment().toDate()}
                    selected={this.state.startDate}
                    onChange={this.handleDateChange}
                  />
                ) : (
                  <p>Please select at least one (1) service</p>
                )}
              </div>
              <div className={(BookStyles.formGroup, BookStyles.timePicker)}>
                <h2>Time</h2>
                {availableTimes ? (
                  this.renderAvailableTimes()
                ) : (
                  <p>Please first select date and service(s)</p>
                )}
              </div>
            </>
          )}

          {this.state.bookedAppointment && (
            <>
              <div className={BookStyles.loaderWrapper}>
                {this.state.success ? (
                  <>
                    <p>{this.state.success}</p>
                    <Link to="/">Go back home</Link>
                  </>
                ) : (
                  <>
                    <div className={BookStyles.loader} />
                    <p>Booking your appointment</p>
                  </>
                )}
              </div>
              <div className={BookStyles.overlay}></div>
            </>
          )}

          {this.state.error && (
            <div className={BookStyles.error} onClick={this.clearError}>
              {this.state.error}
            </div>
          )}

          <div className={BookStyles.submit}>
            <p>Total: ${total}</p>{" "}
            <button
              onClick={this.handleSubmit}
            >{`Book now with ${barber}`}</button>
          </div>
        </form>
      </section>
    )
  }
}

Book.defaultProps = {
  services: [
    {
      service: "Hair cut",
      price: 25,
      checked: false,
      duration: 30,
    },
    {
      service: "Child hair cut",
      price: 15,
      checked: false,
      duration: 30,
    },
  ],
}

export default Book
